import { HELP_MENU_CONTENT_TYPE } from '../help-menu/helpMenuEnums';
import { HelpContent } from '../help-menu/helpMenuInterfaces';

export const beingResponsibleLinks = {
  selfAssessment: 'https://www.gamcare.org.uk/get-advice/self-assessment-tool',
};

export const content: HelpContent[] = [
  {
    type: HELP_MENU_CONTENT_TYPE.PARAGRAPH,
    contentId: 'help_being_responsible.responsible_gambling',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET,
    contentId: 'help_being_responsible.gambling_to_entertain',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET,
    contentId: 'help_being_responsible.gamble_losable_money',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET,
    contentId: 'help_being_responsible.set_limits_to_control',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET,
    contentId: 'help_being_responsible.no_gambling_over_emotions_substances',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET,
    contentId: 'help_being_responsible.take_breaks',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET,
    contentId: 'help_being_responsible.no_gambling_influence_over_life_responsibilities',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.PARAGRAPH,
    style: 'bold',
    contentId: 'help_being_responsible.dependency_recover',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.LINK,
    beforeLinkContentId: 'help_being_responsible.self_assessing',
    link: beingResponsibleLinks.selfAssessment,
    afterLinkContentId: 'help_being_responsible.breakdown',
  },
];
